import { DOCUMENT_GROUP_NAMES } from '@/creditflowresearch/domain/DocumentGroup';
import { transformDocumentTypeGroups } from '@/creditflowresearch/application/Dictionaries/serverSide/legacyMappers';
import type { IDictionaryDocumentTypeGroup } from '@/creditflowresearch/domain/vo/IDictionary';
import type { IResearchDocumentGroup } from '@/creditflowresearch/domain/vo/research/IResearchDocumentGroup';

type TGroupId = string | null;

export const makeEmptyGroupIds = (response) => {
  const researchGroups = {
    [DOCUMENT_GROUP_NAMES.ALL]: response.all,
    ...response.byGroup,
  };

  return Object.keys(researchGroups).reduce(
      (groupIds: TGroupId[], groupId: string) => {
        if (researchGroups[groupId].count === 0) {
          groupIds.push(groupId === DOCUMENT_GROUP_NAMES.ALL ? null : groupId);
        }
        return groupIds;
      }, []);
};

// v1 pages (deal, issuer, overviews) carry the transformed list; v2 pages declare `documentTypeGroups`.
export const resolveResearchDocumentGroupList = (
  legacyList: IResearchDocumentGroup[] | undefined,
  documentTypeGroups: IDictionaryDocumentTypeGroup[] = [],
): IResearchDocumentGroup[] => legacyList ?? transformDocumentTypeGroups(documentTypeGroups);
